var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9583 6.77075H18.9692M7.58332 2.08325H18.4167C21.4082 2.08325 23.8333 4.4151 23.8333 7.29159V17.7083C23.8333 20.5847 21.4082 22.9166 18.4167 22.9166H7.58332C4.59178 22.9166 2.16666 20.5847 2.16666 17.7083V7.29159C2.16666 4.4151 4.59178 2.08325 7.58332 2.08325ZM17.3333 11.8437C17.467 12.7106 17.313 13.596 16.8932 14.3739C16.4734 15.1518 15.8092 15.7826 14.9951 16.1767C14.1809 16.5707 13.2583 16.7078 12.3584 16.5686C11.4585 16.4294 10.6272 16.0208 9.98273 15.4011C9.33823 14.7814 8.91337 13.9821 8.76856 13.1168C8.62376 12.2515 8.76639 11.3644 9.17618 10.5816C9.58596 9.79872 10.242 9.16006 11.0511 8.75642C11.8601 8.35277 12.7809 8.2047 13.6825 8.33325C14.6022 8.46438 15.4536 8.87644 16.111 9.50857C16.7684 10.1407 17.1969 10.9594 17.3333 11.8437Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.1e69af7a941003f223a4c10ba153805d.svg";
export { ForwardRef as ReactComponent };